import React from "react";
import { stats } from "../data/landing";
export function StatsStrip() {
  return <section aria-label="Offer at a glance" className="border-y border-line bg-soft" data-id="element-166" data-mp="ghf7ebxmgv5j">
      <div className="mx-auto max-w-[1180px] px-5 py-10 sm:px-8" data-id="element-167" data-mp="2hvyvi0wfhsp">
        <dl className="grid grid-cols-2 overflow-hidden rounded-xl border border-line bg-white lg:grid-cols-4" data-id="element-168" data-mp="2jqjswc679ws">
          {stats.map((stat, i) => <div key={stat.label} className={`px-3 py-7 text-center ${i % 2 === 1 ? "border-l border-line" : ""} ${i >= 2 ? "border-t border-line lg:border-t-0" : ""} ${i === 2 ? "lg:border-l" : ""}`} data-id="element-169" data-mp="v61ke6zs1atl" data-mpi={i}>
              <dt className="sr-only" data-id="element-170" data-mp="qfuxqcots0dz">{stat.label}</dt>
              <dd className="font-display text-[40px] font-extrabold leading-none text-navy sm:text-5xl" data-id="element-171" data-mp="qejs07btkik8">{stat.value}</dd>
              <dd className="mt-2 text-[11px] font-bold uppercase tracking-[0.14em] text-teal" data-id="element-172" data-mp="1e44ayq7z3fti">{stat.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}